module.exports = __webpack_public_path__ + "images/party-animal-ece15cba615163e560f4520606427492.png";